<template>
  <div>
    <template v-if="profiles !== null">
      <div class="row menubar">
        <input
          type=text v-model="search" placeholder="Zoeken"
          class="searchbar" style="width: 100px"
        >
        <button style="float: right;" @click="download">
          Download ({{ profiles.length }} / {{ profiles.length + failedProfiles.length }})
        </button>
        <inputDropdown
          :array="statusTypes"
          v-model="selectedStatusType"
          displayPrefix="Status: "
          style="float:right"
          :cb="dropdownCB"
        />
        <inputDropdown
          :array="groups"
          v-model="grouping"
          displayPrefix="Sort: "
          :cb="dropdownCB"
          style="float:right"
        />
        <inputDropdown
          :array="filterTypes"
          v-model="selectedFilterType"
          displayPrefix="Filter: "
          style="float:right"
          :cb="dropdownCB"
        />
      </div>

      <div class="card">
        <table width=100%>
          <thead class="table-legend">
            <tr>
              <th>#</th>
              <th>Type</th>
              <th colspan=3>Huidig profiel</th>
              <th width="70">Voortgang<br> AOW</th>
              <th width="70">Looptijd<br> Uitkeren</th>
              <th colspan=2>Max</th>
              <th colspan=3>Optimale profiel</th>
              <th></th>
            </tr>
          </thead>
          <tr
            v-for="(p) in slice(
              filter(filter(filter(profilesSorted,typeFilter),statusFilter),searchFilter),
              currentPage * resultsPerPage,
              (currentPage + 1)* resultsPerPage,
            )"
            :key="`s${p.port}`"
          >
            <!-- port / status -->
            <td width="50">
              {{ p.port }}
              <br />
              <span class="grey">{{toStatus(p.status)}}</span>
            </td>
            <!-- Type -->
            <td>{{ p.typeName }}</td>
            <!-- Profiel / shares / score-->
            <td :class="{ 'red': !p.dontchange }">{{ p.currentProfileName }}</td>
            <td
              :class="{ 'red': (p.currentProfileName== 'A' && (p.shares > 25 || p.shares < 5))
              ||  (p.currentProfileName== 'B' && (p.shares > 45 || p.shares < 25))
              ||  (p.currentProfileName== 'C' && (p.shares > 60 || p.shares < 40))
              ||  (p.currentProfileName== 'D' && (p.shares > 75 || p.shares < 55))
              ||  (p.currentProfileName== 'E' && (p.shares > 95 || p.shares < 75))
            }">{{ formatPrice(Number(p.shares)) }}%</td>
            <td class="number" :class="{ 'red': Number(p.currentScore) < 50 }">
              {{ formatPrice(Number(p.currentScore)) }}
            </td>
            <td>
              <span :class="{'red': p.progress > 95}">{{ formatPrice(p.progress) }}%</span>
              <br v-if="[7, 9, 11].includes(Number(p.type))" />
              <span v-if="[7, 9, 11].includes(Number(p.type))" :class="{
                'red': p.aowDate < new Date(),
              }">
                {{
                  p.aowDate
                    ? new Date(p.aowDate).toLocaleDateString()
                    : 'No bday'
                }}
              </span>
            </td>
            <td>
              <span :class="{ 'red': p.daysleft < 365 * 5 }">
                <template v-if="p.daysleft > 365">
                  {{ Math.ceil(p.daysleft / 365) }} jr
                </template>
                <template v-else-if="p.daysleft > 1">
                  {{ Math.ceil(p.daysleft) }} dgn
                </template>
                <template v-else-if="p.daysleft > 0">
                  1 dg
                </template>
                <template v-else>
                  Bereikt
                </template>
              </span>
              <br v-if="[7, 9, 11].includes(Number(p.type))" />
              <span v-if="[7, 9, 11].includes(Number(p.type))" :class="{
                'red': p.startPayoutDate < new Date(),
              }">
                {{
                  p.startPayoutDate
                    ? new Date(p.startPayoutDate).toLocaleDateString()
                    : 'No bday'
                }}
              </span>
            </td>
            <td :class="{ 'red': p.intakeProfileName == '-' }">
              {{ p.intakeProfileName }}
            </td>
            <td>{{ toMaxExtra(p) }}</td>
            <td :class="{ 'red': p.optimalProfileName == 'Sparen' }">
              {{ p.optimalProfileName }}
            </td>
            <td class="number">{{ formatPrice(Number(p.optimalScore)) }}</td>
            <td class="number">
              <span v-if="Number(p.optimalScore) > Number(p.currentScore)">
                +
              </span>
              {{ formatPrice(Number(p.optimalScore) - Number(p.currentScore)) }}
              <span v-if="Number(p.optimalScore) > Number(p.currentScore)">(
                +{{ formatPrice(
                  (Number(p.optimalScore) - Number(p.currentScore))
                  / Number(p.currentScore) * 100,
                  false,
                  2
                ) }}%)
              </span>
            </td>
            <td v-if="p.busyIntake">
              <button @click="doOpen(p.busyIntake)" class="secondary">
                <awesomeIcon icon="redo-alt"/> Vervolg intake {{ p.busyIntake }}
              </button>
            </td>
            <td v-else>
              <button @click="redoIntake(p.port)" class="secondary">
                <awesomeIcon icon="clipboard-list"/> Open her-intake!
              </button>
            </td>

          </tr>
        </table>
        <pagerElement
          v-model="currentPage"
          :records="
            filter(
              filter(filter(profilesSorted,typeFilter),statusFilter),
              searchFilter
            ).length
          "
          :resultsPerPage="resultsPerPage"
        />
      </div>

      <div class="card subheader" v-if="failedProfiles.length > 0">
        <h2 @click="showToDo = !showToDo" class="title" style="cursor: pointer">To do</h2>
        <span @click="showToDo = !showToDo" class="showToDo">
          <awesomeIcon size="lg" :icon="showToDo ? 'chevron-up' : 'chevron-down'" />
        </span>
        <div class="card" v-if="showToDo">
          <table>
            <tr v-for="(group, index) in chunk(failedProfiles, 7)" :key="index">
              <td
                v-for="failed in group"
                :key="failed.port"
              >
                {{ failed.port }}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </template>
    <div v-else class="loader" />
  </div>
</template>

<script>
import {
  slice, filter, reject, sortBy, find, chunk,
} from 'lodash-es';
import FileSaver from 'file-saver';

export default {
  name: 'AdminSats',
  data() {
    return {
      search: '',
      profileNames: null,
      profiles: null,
      failedProfiles: null,
      currentPage: 0,
      resultsPerPage: 20,
      showToDo: false,
      selectedFilterType: 'haalbaarheid',
      filterTypes: [
        {
          label: 'Lifecycle',
          value: 'lifecycle',
        },
        {
          label: 'Te hoog',
          value: 'max',
        },
        {
          label: 'Aanpassen (profiel)',
          value: 'aanpassen2',
        },
        {
          label: 'Aanpassen (sparen)',
          value: 'aanpassen',
        },
        {
          label: 'Onmogelijk',
          value: 'nul',
        },
        {
          label: 'Voortgang',
          value: 'voortgang',
        },
        {
          label: 'Looptijd',
          value: 'looptijd',
        },
        {
          label: 'Balans',
          value: 'balans',
        },
        {
          label: 'Haalbaarheid',
          value: 'haalbaarheid',
        },
        {
          label: 'AOW bereikt',
          value: 'aowbereikt',
        },
        {
          label: 'AOW 0,5 jaar',
          value: 'aowhalfjaar',
        },
        {
          label: 'AOW 1 jaar',
          value: 'aow1jaar',
        },
        {
          label: 'AOW 2 jaar',
          value: 'aow2jaar',
        },
        {
          label: 'Uitkeren 0,5 jaar',
          value: 'uitkerenhalfjaar',
        },
        {
          label: 'Uitkeren 1 jaar',
          value: 'uitkeren1jaar',
        },
        {
          label: 'Uitkeren 2 jaar',
          value: 'uitkeren2jaar',
        },
        {
          label: 'Alles',
          value: '',
        },
      ],
      selectedStatusType: 'Actief',
      statusTypes: [
        {
          value: 'Actief',
        },
        {
          value: 'Bevroren',
        },
        {
          value: 'Gepauzeerd',
        },
        {
          value: 'Gesloten',
        },
        {
          value: 'Alles',
        },
      ],
      grouping: 'daysleft',
      groups: [
        {
          label: 'Doeldatum',
          value: 'daysleft',
        },
        {
          label: 'AOW datum',
          value: 'aowDate',
        },
        {
          label: 'Start uitkeren',
          value: 'startPayoutDate',
        },
        {
          label: 'Haalbaarheid oplopend',
          value: 'currentScore',
        },
        {
          label: 'Haalbaarheid aflopend',
          value: 'currentScore2',
        },
        {
          label: 'Voortgang oplopend',
          value: 'progress',
        },
        {
          label: 'Voortgang aflopend',
          value: 'progress2',
        },
      ],
    };
  },
  created() {
    this.getProfiles();
  },
  computed: {
    profilesSorted() {
      return sortBy(
        this.profiles,
        [
          find(this.groups, { value: this.grouping }).value,
          (o) => o.dontchange,
        ],
      );
    },
  },
  methods: {
    chunk,
    filter,
    slice,
    aowFilterCheck(aowAge, months) {
      return new Date(
        aowAge.getFullYear(),
        aowAge.getMonth() - months,
        aowAge.getDate(),
      ) < new Date();
    },
    dropdownCB() {
      this.currentPage = 0;
    },
    doOpen(intake) {
      window.open(`?intake=${intake}`);
    },
    download() {
      const lineArray = [];
      lineArray.push(Object.keys(this.profiles[0]).join(';'));
      this.profiles.forEach((infoArray) => {
        const values = Object.values(infoArray).map((o, index) => {
          if (Number(o) && index !== 0) {
            return String(Math.round(Number(o) * 100) / 100).replace('.', ',');
          }
          return o;
        });
        lineArray.push(values.join(';'));
      });
      const file = new File(
        [lineArray.join('\n')],
        `${(new Date()).getFullYear()}${(new Date()).getMonth() + 1 < 10 ? `0${(new Date()).getMonth() + 1}` : (new Date()).getMonth() + 1}${(new Date()).getDate() < 10 ? `0${(new Date()).getDate()}` : (new Date()).getDate()}-sats.csv`,
        { type: 'text/csv;charset=utf-8' },
      );
      FileSaver.saveAs(file);
    },
    toStatus(status) {
      if (status === 1) {
        return 'bevroren';
      }
      if (status === 2) {
        return 'gepauzeerd';
      }
      if (status === 3) {
        return 'gesloten';
      }
      return 'actief';
    },
    redoIntake(port) {
      this.sdk.redoIntake(port, () => {
        this.getProfiles();
      });
    },
    toMaxExtra(obj) {
      if (Number(obj.lifecycle) === 0) {
        return '(No lifecycle)';
      }
      if (obj.daysleft < 365 && obj.currentProfile > 15) {
        return '(Max A)';
      }
      if (obj.daysleft < 2 * 365 && obj.currentProfile > 16) {
        return '(Max B)';
      }
      if (obj.daysleft < 3 * 365 && obj.currentProfile > 17) {
        return '(Max C)';
      }
      if (obj.daysleft < 4 * 365 && obj.currentProfile > 18) {
        return '(Max D)';
      }
      return '';
    },
    statusFilter(obj) {
      if (this.selectedStatusType === 'Alles') {
        return true;
      }
      if (this.toStatus(obj.status) === this.selectedStatusType.toLowerCase()) {
        return true;
      }
      return false;
    },
    searchFilter(obj) {
      if (!this.search || obj.port.toLowerCase().indexOf(this.search) > -1) {
        return true;
      }
      return false;
    },
    typeFilter(obj) {
      if (this.selectedFilterType === 'lifecycle' && Number(obj.lifecycle) === 1 && (
        (obj.daysleft < 365 && obj.currentProfile > 15)
        || (obj.daysleft < 2 * 365 && obj.currentProfile > 16)
        || (obj.daysleft < 3 * 365 && obj.currentProfile > 17)
        || (obj.daysleft < 4 * 365 && obj.currentProfile > 18)
      )) {
        return true;
      }
      if (this.selectedFilterType === 'max' && Number(obj.currentProfile) > Number(obj.intakeProfile)) {
        return true;
      }
      if (this.selectedFilterType === 'aanpassen'
        && obj.optimalProfileName === 'Sparen'
        && (Number(obj.optimalScore) - Number(obj.currentScore)) > 0) {
        // (Number(obj.optimalScore) - Number(obj.currentScore))/Number(obj.currentScore) > 0.10) {
        return true;
      }
      if (this.selectedFilterType === 'aanpassen2'
        && obj.optimalProfileName !== 'Sparen'
        && (Number(obj.optimalScore) - Number(obj.currentScore) > 0)) {
        // (Number(obj.optimalScore) - Number(obj.currentScore))/Number(obj.currentScore) > 0.10) {
        return true;
      }
      if (this.selectedFilterType === 'voortgang' && (Number(obj.portValue) / Number(obj.target)) * 100 > 95) {
        return true;
      }
      if (this.selectedFilterType === 'looptijd' && obj.daysleft < 365 * 5) {
        return true;
      }

      if (this.selectedFilterType === 'sparen' && obj.optimalProfileName === 'Sparen' && obj.optimalScore > 0) {
        return true;
      }
      if (this.selectedFilterType === 'nul' && obj.optimalProfileName === 'Sparen' && obj.optimalScore === 0) {
        return true;
      }

      // Filter for AOW
      if (
        this.selectedFilterType === 'aowbereikt'
        && obj.aowDate
        && [7, 9, 11].includes(Number(obj.type))
        && this.aowFilterCheck(obj.aowDate, 0)
      ) {
        return true;
      }
      if (
        this.selectedFilterType === 'aowhalfjaar'
        && obj.aowDate
        && [7, 9, 11].includes(Number(obj.type))
        && this.aowFilterCheck(obj.aowDate, 6)
      ) {
        return true;
      }
      if (
        this.selectedFilterType === 'aow1jaar'
        && obj.aowDate
        && [7, 9, 11].includes(Number(obj.type))
        && this.aowFilterCheck(obj.aowDate, 12)
      ) {
        return true;
      }
      if (
        this.selectedFilterType === 'aow2jaar'
        && obj.aowDate
        && [7, 9, 11].includes(Number(obj.type))
        && this.aowFilterCheck(obj.aowDate, 24)
      ) {
        return true;
      }
      if (
        this.selectedFilterType === 'uitkerenhalfjaar'
        && obj.startPayoutDate
        && [7, 9, 11].includes(Number(obj.type))
        && this.aowFilterCheck(obj.startPayoutDate, 6)
      ) {
        return true;
      }
      if (
        this.selectedFilterType === 'uitkeren1jaar'
        && obj.startPayoutDate
        && [7, 9, 11].includes(Number(obj.type))
        && this.aowFilterCheck(obj.startPayoutDate, 12)
      ) {
        return true;
      }
      if (
        this.selectedFilterType === 'uitkeren2jaar'
        && obj.startPayoutDate
        && [7, 9, 11].includes(Number(obj.type))
        && this.aowFilterCheck(obj.startPayoutDate, 24)
      ) {
        return true;
      }

      if (this.selectedFilterType === 'balans' && obj.shares > 0 && obj.portValue > 1 && (
        (obj.currentProfileName === 'A' && (obj.shares > 25 || obj.shares < 5))
        || (obj.currentProfileName === 'B' && (obj.shares > 45 || obj.shares < 25))
        || (obj.currentProfileName === 'C' && (obj.shares > 60 || obj.shares < 40))
        || (obj.currentProfileName === 'D' && (obj.shares > 75 || obj.shares < 55))
        || (obj.currentProfileName === 'E' && (obj.shares > 95 || obj.shares < 75))
      )) {
        return true;
      }
      if (this.selectedFilterType === 'haalbaarheid' && obj.currentScore < 50) {
        return true;
      }
      if (this.selectedFilterType === '') {
        return true;
      }
      return false;
    },
    typeToText(type) {
      if (type === 1) {
        return 'Zorg';
      }
      if (type === 2) {
        return 'Huis';
      }
      if (type === 3) {
        return 'Kind';
      }
      if (type === 4) {
        return 'Aankoop';
      }
      if (type === 5) {
        return 'Pensioen';
      }
      if (type === 6) {
        return 'Levensonderhoud';
      }
      if (type === 7) {
        return 'Pensioen (box 1)';
      }
      if (type === 8) {
        return 'Leefrente';
      }
      if (type === 9) {
        return 'Gouden handdruk (opbouwend)';
      }
      if (type === 10) {
        return 'Gouden handdruk (uitkerend)';
      }
      if (type === 11) {
        return 'Netto lijfrente (opbouwend)';
      }
      if (type === 12) {
        return 'Netto lijfrente (uitkerend)';
      }
      return 'Opbouw';
    },
    getProfiles() {
      this.sdk.getProfiles((response) => {
        if (response.status === 200) {
          this.profileNames = response.data;
          this.getCalcs();
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      });
    },
    getCalcs() {
      this.profiles = null;
      this.sdk.getAdminProfileCalcs((response) => {
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i += 1) {
            const currentProfile = find(
              this.profileNames,
              { id: response.data[i].currentProfile },
            );
            const optimalProfile = find(
              this.profileNames,
              { id: response.data[i].optimalProfile },
            );
            const intakeProfile = find(
              this.profileNames,
              { id: response.data[i].intakeProfile },
            );

            // eslint-disable-next-line
            response.data[i].brand = currentProfile.brand;
            // eslint-disable-next-line
            response.data[i].currentProfileName = currentProfile ? currentProfile.name.replace('Doelbeleggen ', '') : '-';
            // eslint-disable-next-line
            response.data[i].optimalProfileName = optimalProfile ? optimalProfile.name.replace('Doelbeleggen ', '') : '-';
            // eslint-disable-next-line
            response.data[i].intakeProfileName = intakeProfile ? intakeProfile.name.replace('Doelbeleggen ', '') : '-';
            response.data[i].intakeProfile = intakeProfile ? response.data[i].intakeProfile : 0;
            // eslint-disable-next-line
            response.data[i].typeName = this.typeToText(response.data[i].type);
            response.data[i].dontchange = response.data[i].currentProfile
              === response.data[i].optimalProfile;
            response.data[i].daysleft = (
              (new Date(response.data[i].targetDate)).getTime()
              - (new Date()).getTime()
            ) / 1000 / 24 / 60 / 60;
            if ([7, 9, 11].includes(Number(response.data[i].type))) {
              // Only opbouw
              response.data[i].aowDate = this.calcAowAge(response.data[i].birthday, 0);
              response.data[i].startPayoutDate = this.calcAowAge(
                response.data[i].birthday,
                Number(response.data[i].type) === 9 ? 0 : 5,
              );
            }
            response.data[i].progress = (
              Number(response.data[i].portValue)
              / Number(response.data[i].target)
            ) * 100;
            response.data[i].progress2 = Number.isFinite(response.data[i].progress)
              ? 100 - response.data[i].progress
              : response.data[i].progress;
            response.data[i].currentScore2 = 100 - response.data[i].currentScore;

            response.data[i].busyIntake = response.data[i].busyIntakes
              && response.data[i].busyIntakes[0]
              ? response.data[i].busyIntakes[0].id
              : '';
            delete response.data[i].busyIntakes;
          }
          this.profiles = filter(response.data, 'portSat');
          this.failedProfiles = reject(response.data, 'portSat');
          this.$nextTick(() => {
            this.resultsPerPage = 20;
          });
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  .subheader {
    margin-top: 10px;
    padding: 10px 20px;
  }
  .showToDo {
    float: right;
    cursor: pointer;
  }
</style>
